import React, { FC, useEffect, useState } from 'react';
import { ChunkedTask } from 'src/shared/chunkedTask';
import { T } from 'src/shared/helpers';
import UploadProgressRow from '../uploadProgressRow';
import { AreaTemplateInfo } from './helpers';
import { Dialog } from '../dialog';

interface LayersUploadDialogProps {
    file: File;
    fileID: string;
    onComplete: (result: AreaTemplateInfo) => void;
}

const LayersUploadDialog: FC<LayersUploadDialogProps> = ({ file, fileID, onComplete }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        startUpload();
    }, [file]);

    const startUpload = async () => {
        const chunkedTask = new ChunkedTask('areatemplatetasks', 'areatemplatetasks');
        const response = await chunkedTask.upload(file, { customFileID: fileID }, setProgress);

        const areaTemplateInfo = response.areaTemplateInfo as AreaTemplateInfo;

        onComplete(areaTemplateInfo);
    };

    return (
        <Dialog>
            <UploadProgressRow
                label={progress < 100 ? T._('Uploading PDF...', 'Admin') : T._('Processing PDF...', 'Admin')}
                status={progress < 100 ? 'UPLOADING' : 'PROCESSING'}
                progress={progress}
            />
        </Dialog>
    );
};

export default LayersUploadDialog;
